import React, { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Upload, Divider } from 'antd'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import RingtoneIcon from 'components/icons/Ringtone'
import DownLoadIcon from 'components/icons/DownLoad'
import UploadIcon from 'components/icons/UploadIcon'
import {
  StyledUpload,
  UploadFlex,
  UploadIconDiv,
  UploadFileDiv,
  FileNameDiv,
  HeadTextWrap,
  SubText,
  FirstContent,
  CheckboxLabelWrapper,
  CheckboxLabel,
  SampleDocWrapper,
  SampleDocIcon,
  SampleDocContent,
  SampleDocTitle,
  SampleDocSubtitle,
  NoteContent,
} from './style'
import { FooterFlex } from 'modules/Drives/DownloadAndUpload/DownloadCandidateDrawer/style'
import FileReader from 'components/Uploader/FileReader'
import CustomModal from 'components/Modal/index.js'
import skipRoundIcon from 'components/icons/OBJECTS.svg'
import DullIcon from '../../../../components/icons/DullIcon'
import SmileIcon from '../../../../components/icons/SmileIcon'
import { ResultWrapper, StyledH2 } from '../style'
import Control from 'components/Control/Control'
import { StyledP } from '../style'



const UploadShortlistedDrawer = ({
  uploadShortlisted,
  setUploadShortlisted,
  setIsDrawer,
  stage,
  downloadCandidateSampleTemplate,
  isScoreConfirmed,
  setIsScoreConfirmed,
  nextRoundData,
  selectedRound,
  setSelectedRound,
  handleConfirm,
  isModalOpen,
  setIsModalOpen,
  fileURL,
  setFileURL,
  file,
  setFile,
  loading,
  isFileLoader,
  setIsFileLoader,
  fileList,
  setFileList,
  bulkUploadResult,
  setOtherError,
  setErrorMessage,
  handleResolveConflict,
  finalUpload,
  isFinalUpload,
  handleClearUpload,
  conflictStatus,
  checkType
}) => {

  const onClose = () => {
    setUploadShortlisted(false)
    setIsDrawer(true)
    setFile(null)
    setFileURL('')
    setFileList([])
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('OK')
    }, 0)
  }
  const stageIndex = nextRoundData?.findIndex(
    r => r?.value?.toLowerCase() === stage?.toLowerCase()
  );
  
  const filteredNextRounds = stageIndex >= 0
    ? nextRoundData.slice(stageIndex + 1)
    : nextRoundData;


  const onChangeFileUpload = async info => {
    setIsModalOpen(true)
    setFileList([...fileList, info?.file])
    
    // Reset any previous results
    setOtherError('')
  
  }


  const content = () => {
    return (
      <>
        {/* Note Section */}
          <FirstContent>
            <HeadTextWrap>
              <RingtoneIcon />
              Please note!
            </HeadTextWrap>
            <SubText>Upload only the shortlisted candidates.</SubText>
            <SubText>
              Syncing candidates with Mail ID/Mobile Number is mandatory!
            </SubText>
          </FirstContent>
        {checkType !== 'CV_SCREENING'&& checkType !== 'ASSESMENT' && (
          <CheckboxLabelWrapper>
            <CheckboxLabel>
              <input
                type="checkbox"
                checked={isScoreConfirmed}
                onChange={e => setIsScoreConfirmed(e.target.checked)}
              disabled={stage == 'all_candidates' || stage === null}
              />
              Confirm if your file includes scores for the shortlisted candidates.
            </CheckboxLabel>
          </CheckboxLabelWrapper>
        )}
          {isScoreConfirmed && (
            <NoteContent>
              <SampleDocTitle>
              <strong>Note: </strong>if you're including scores, please add only
              the relevant score Columns
              </SampleDocTitle>
              <SampleDocTitle>in the sheet.</SampleDocTitle>
            </NoteContent>
          )}
        {/* Sample Template Download */}
            <SampleDocWrapper onClick={downloadCandidateSampleTemplate}>
              <SampleDocIcon>
                <DownLoadIcon />
              </SampleDocIcon>
              <SampleDocContent>
                <SampleDocTitle>Candidate Sample Document</SampleDocTitle>
                <SampleDocSubtitle>To bulk upload, use template</SampleDocSubtitle>
              </SampleDocContent>
            </SampleDocWrapper>

        {/* File Upload Area */}
        <StyledUpload
          multiple={false}
          type="file"
          accept={'.xlsx,.xls,.csv'}
          customRequest={dummyRequest}
          onChange={onChangeFileUpload}
          itemRender={() => null}
        >
          <UploadFlex column alignCenter style={{ marginTop: '20px' }}>
            <UploadIconDiv>
              <UploadIcon />
            </UploadIconDiv>
            <UploadFileDiv>Browse for file or Drag and drop</UploadFileDiv>
            <FileNameDiv>Format (.xls, .xlsx, .csv)</FileNameDiv>
          </UploadFlex>
          {fileURL && (
            <FileReader
              file={file}
              setFile={setFile}
              fileURL={fileURL}
              setFileURL={setFileURL}
              setErrorMessage={setErrorMessage}
            />
          )}
        </StyledUpload>
        
        {file && bulkUploadResult && Object?.keys(bulkUploadResult)?.length !== 0 && (
                  <Control column top="40px" bottom="2px">
                    {Number(bulkUploadResult?.data?.matchedCandidateIds?.length) >
                    0 ? (
                      <ResultWrapper alignCenter>
                        <SmileIcon />
                        <StyledH2>
                          {Number(
                            bulkUploadResult?.data?.matchedCandidateIds?.length
                          )}
                          &nbsp;student
                          {bulkUploadResult?.data?.matchedCandidateIds?.length > 1
                            ? 's'
                            : ''}
                          {Number(
                            bulkUploadResult?.data?.matchedCandidateIds?.length
                          ) > 1
                            ? ' are '
                            : ' is '}
                          successfully shortlisted.
                        </StyledH2>
                      </ResultWrapper>
                    ) : (
                      <ResultWrapper alignCenter>
                        <DullIcon />
                        <StyledH2>
                          No candidates match for the above sheet
                        </StyledH2>
                      </ResultWrapper>
                    )}
                    {Number(bulkUploadResult?.data?.conflictCandidates?.length) >
                      0 && (
                      <>
                        <ResultWrapper alignCenter>
                          <DullIcon />
                          <StyledH2>
                            <>{'Status conflict with '}</>
                            {bulkUploadResult?.data?.conflictCandidates?.length}
                            {bulkUploadResult?.data?.conflictCandidates?.length >
                            1
                              ? ' students'
                              : ' student'}
                          </StyledH2>
                        </ResultWrapper>
                        {bulkUploadResult?.data?.conflictCandidates?.length !==
                          0 && (
                          <Control column top="10px">
                            <Button.Danger
                              wordBreak
                              text={'Resolve Conflicts'}
                              width="max-content"
                              onClick={() => handleResolveConflict()}
                            />
                          </Control>
                        )}
                      </>
                    )}
                    {bulkUploadResult?.data?.rejectionCandidateIds?.length !==
                        0 && (
                        <Control column top="30px">
                          {finalUpload == 0 && (
                            <StyledP>
                              Is this the last batch you are uploading?
                            </StyledP>
                          )}
                          {finalUpload > 0 && (
                            <StyledP>
                              {stage === 'offer' || conflictStatus === 'ACCEPTED'
                                ? `Do you want to mark all the other students as “Offer
                  declined”`
                                : `Do you want to reject the other candidates who weren't selected?`}
                            </StyledP>
                          )}

                          <Control top="8px" gap="5%">
                            <Button.Secondary
                              text="No"
                              onClick={() => isFinalUpload(-1)}
                            />
                            <Button.Primary
                              text="Yes"
                              onClick={() => isFinalUpload(+1)}
                            />
                          </Control>
                        </Control>
                      )}
                  </Control>
              )}
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd centerVertically>
        <Button.Secondary width="88px" text="Cancel" onClick={onClose} />
        <Button.Primary
          width="110px"
          text={fileURL ? 'Update' : 'Next'}
          loading={loading}
          onClick={handleClearUpload}
        />
      </FooterFlex>
    )
  }

  return (
    <>
      <Drawer
        width="40%"
        title={'Shortlisted Candidates'}
        placement="right"
        visible={uploadShortlisted}
        content={content()}
        footer={footer()}
        onClose={onClose}
        closable
      />
       <CustomModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false)
          setIsFileLoader(false)
        }}
        onConfirm={loading === true ? null : handleConfirm}
        iconSrc={skipRoundIcon}
        selectedRound={selectedRound}
        onRoundChange={setSelectedRound}
        rounds={filteredNextRounds}
        imageWidth={120}
        imageHeight={140}
        width={800}
        ButtonWidth="64px"
        ButtonHeight="38px"
        ButtonBorderRadius = "10px"
        height={400}
        yesText="Yes"
        noText="NO"
        titleText="Bulk upload shortlisted students into next applicable round"
        subTitleText="Select next applicable round"
        loading={isFileLoader}
      />
    </>
  )
}

export default UploadShortlistedDrawer
